// extracted by mini-css-extract-plugin
export default {"blue":"#00a9e0","blue100":"#b3e5f6","textPrimary":"#212121","blueIcon":"Styling_blueIcon__IbVLL","large":"Styling_large__NMdUG","chip":"Styling_chip__DH1uw"};